import { useMemo } from 'react';
import cx from 'classnames';
import { Box, makeStyles } from '@material-ui/core';

import withProps from 'hooks/withProps';
import Text from 'components/Text';
import TextLabel from 'components/TextLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  price: {
    display: 'inline-flex',
    gap: 1,
    alignItems: 'flex-start',
  },
  sup: {
    verticalAlign: 'top',
  },
  value: {},
  currency: {},

  // Sizes
  small: {
    gap: 4,

    '& > $price': {
      height: 14,

      '& > $value': {
        fontSize: 16,
      },
      '& > $sup': {
        fontSize: 6,
      },
    },
  },
  medium: {
    gap: 6,

    '& > $price': {
      height: 20,

      '& > $value': {
        fontSize: 20,
      },
      '& > $sup': {
        fontSize: 8,
      },
    },
  },
  large: {
    gap: 8,

    '& > $price': {
      height: 20,

      '& > $value': {
        fontSize: 24,
      },
      '& > $sup': {
        fontSize: 8,
      },
    },
  },
}));

const currencyFormatter = (v, options = {}) => {
  const { cents = true } = options;

  if (!Number.isFinite(v)) {
    if (!v && typeof v !== 'number') {
      return '';
    }
    return '';
  }
  const value = cents ? v / 100 : v;

  return value.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

const MainText = withProps(Text, {
  component: 'span',
  display: 'inline',
  variant: 'subtitle2-bold',
  lineHeight: '0.87em',
  color: 'colors.grey900',
  fontSize: 16,
  view: 'desktop',
});
const SupText = withProps(MainText, {
  component: 'sup',
  lineHeight: '1.33em',
});

const InlinePrice = (props) => {
  const {
    value,
    color,
    currency,
    className,
    size = 'small',
    component = 'span',
    ...rest
  } = props;

  const price = useMemo(() => currencyFormatter(value), [value]);
  const classes = useStyles();

  const [ceil, cents] = useMemo(() => {
    const [v1, v2] = price.split('.');
    const r1 = Number.isFinite(Number.parseInt(v1)) ? v1 : '0';
    const r2 = Number.isFinite(Number.parseInt(v2)) ? v2 : '00';
    return [r1, r2];
  }, [price]);

  const rootClasses = cx(classes.root, classes[size], className);

  return (
    <Box component={component} className={rootClasses} {...rest}>
      <div className={classes.price}>
        <SupText className={classes.sup} color={color}>
          $
        </SupText>
        <MainText className={classes.value} color={color}>
          {ceil}
        </MainText>
        <SupText className={classes.sup} color={color}>
          {cents}
        </SupText>
      </div>

      {currency && (
        <TextLabel
          className={classes.currency}
          view={size === 'small' ? 'mobile' : 'desktop'}
        >
          {currency}
        </TextLabel>
      )}
    </Box>
  );
};

export default InlinePrice;
